import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import _ from 'lodash';

import { 
  nextStep,
  addMobileQuestionerData,
  getMobileStepsData,
 } from '../../actions/steps';
import { getUserData } from '../../actions/auth';
import { questionarySteps } from '../../constants/questioner';
import steps from '../../components/Steps/steps';
import ProgressPage from '../../components/ProgressPage/ProgressPage';
import DishesPage from '../../components/DishesPage/DishesPage';

import styles from './Dashboard.module.css';

const Dashboard = (props) => {
  const {
    getMobileStepsData,
    getUserData,
    addMobileQuestionerData,
    nextStep,
    stepsData,
  } = props;

  const [showProgress, setShowProgress] = useState(false);
  const [showDishesPage, setShowDishesPage] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    getMobileStepsData();
    getUserData();
  }, []);

  // console.log('===location', location);
  // console.log('===navigate', navigate);

  useEffect(() => {
    if (stepsData?.step >= questionarySteps[0].step) {
      if (location.pathname === '/edit') {
        return navigate('/');
      }
      setShowDishesPage(true);
    } else if (stepsData?.step === 0) {
      setShowDishesPage(false);
      setShowProgress(false);
    }
  }, [stepsData]);

  // country GB need for first version of site (You can delete it in future)
  if (!stepsData?.step && stepsData.country === 'GB') {
    return;
  }

  const continueGenerationHandler = () => {
    // console.log('===continueGenerationHandler');
    setShowProgress(true);
    setShowDishesPage(false);
  };

  if (showDishesPage) {
    return (
      <DishesPage 
        onSuccess={continueGenerationHandler}
      />
    );
  }

  if (showProgress) {
    return (
      <ProgressPage />
    );
  }

  const nextStepHandler = (data = {}, callback) => {
    // console.log('===data', data);

    if (_.isEmpty(data)) {
      nextStep();
    } else {
      addMobileQuestionerData(data, callback);
    }
  };

  const StepComponent = steps[stepsData.step];

  if (!StepComponent) {
    return;
  }

  return (
    <div className={styles.wrapper}>
      <StepComponent
        onSave={nextStepHandler}
        stepsData={stepsData}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  stepsData: state.steps.stepsData,
});

const mapDispatchToProps = {
  getMobileStepsData,
  getUserData,
  nextStep,
  addMobileQuestionerData,
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);